import { DAY, MINUTE, type ProgramData, type UnsavedProgramTask } from '@terros/common'

export function setTaskPriority<T extends UnsavedProgramTask>(tasks: T[]): T[] {
  return tasks.map((t, i) => ({ ...t, priority: tasks.length - i }))
}

export function getDefaultTaskValues({ completion = 'timeline' }: Pick<ProgramData, 'completion'>): UnsavedProgramTask {
  const hasSchedule = completion === 'timeline'

  return {
    type: 'WatchVideo',
    priority: 1,
    subject: '',
    body: '',
    expiration: 0,
    schedule: hasSchedule ? { type: 'day', days: [] } : { type: 'none' },
    duration: hasSchedule ? DAY / MINUTE : undefined,
    openSince: hasSchedule ? 0 : undefined,
    criteria: [],
  }
}
